import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { AccountService } from '../../../services/account.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SubscriptionNotificationService } from '../../../services/subscription-notification.service';

@Component({
  selector: 'modal-confirm-unsubscribe',
  template: require('./modal-confirm-unsubscribe.component.pug'),
  styles: [require('./modal-confirm-unsubscribe.component.css').toString()],
})
export class ModalConfirmUnsubscribeComponent implements OnInit {
  // Options to pass to the modal:
  form: FormGroup;
  onDelete: (onFailure: onSmartFailure) => void;
  public reason: Subject<any>;
  buttonTitle = 'Cancel with immediate effect';
  accountId: string;
  cancelReason: string;

  // -------------------------------------------------------------------
  constructor(
    public bsModalRef: BsModalRef,
    private accountService: AccountService,
    private subscriptionNotificationService: SubscriptionNotificationService,
    fb: FormBuilder,
  ) {
    this.form = fb.group({
      cancelReason: ['', Validators.required],
    });
  }

  // -------------------------------------------------------------------
  ngOnInit() {
    this.reason = new Subject();
  }

  // -------------------------------------------------------------------
  onCancel() {
    this.bsModalRef.hide();
  }

  // -------------------------------------------------------------------
  cancel(_data: any, onsuccess: onSmartSuccess, onfailure: onSmartFailure) {
    this.accountService.cancelSubscription(
      this.accountId,
      this.getCancelReason(),
      result => {
        onsuccess();
        this.subscriptionNotificationService.planName.next('expired');
        this.reason.next(true);
        this.bsModalRef.hide();
      },
      error => {
        onfailure(error);
      },
    );
  }

  // -------------------------------------------------------------------
  isDisabled() {
    if (this.getCancelReason().length < 3) {
      return true;
    }
    return false;
  }

  // -------------------------------------------------------------------
  getCancelReason() {
    return this.form.get('cancelReason').value;
  }
}
